"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemotionRiveCanvas = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const canvas_advanced_1 = __importDefault(require("@rive-app/canvas-advanced"));
const react_1 = __importStar(require("react"));
const remotion_1 = require("remotion");
const map_enums_js_1 = require("./map-enums.js");
const RemotionRiveCanvasForwardRefFunction = ({ src, fit = 'contain', alignment = 'center', artboard: artboardName, animation: animationIndex, onLoad = null, assetLoader, enableRiveAssetCdn = true, }, ref) => {
    const { width, fps, height } = (0, remotion_1.useVideoConfig)();
    const frame = (0, remotion_1.useCurrentFrame)();
    const canvas = (0, react_1.useRef)(null);
    const [riveCanvasInstance, setRiveCanvas] = (0, react_1.useState)(null);
    const [err, setError] = (0, react_1.useState)(null);
    const { delayRender, continueRender } = (0, remotion_1.useDelayRender)();
    const [handle] = (0, react_1.useState)(() => delayRender());
    const lastFrame = (0, react_1.useRef)(0);
    if (err) {
        throw err;
    }
    const [rive, setRive] = (0, react_1.useState)(null);
    (0, react_1.useImperativeHandle)(ref, () => {
        return {
            getAnimationInstance() {
                var _a;
                return (_a = rive === null || rive === void 0 ? void 0 : rive.animation) !== null && _a !== void 0 ? _a : null;
            },
            getArtboard() {
                var _a;
                return (_a = rive === null || rive === void 0 ? void 0 : rive.artboard) !== null && _a !== void 0 ? _a : null;
            },
            getRenderer() {
                var _a;
                return (_a = rive === null || rive === void 0 ? void 0 : rive.renderer) !== null && _a !== void 0 ? _a : null;
            },
            getCanvas() {
                return riveCanvasInstance !== null && riveCanvasInstance !== void 0 ? riveCanvasInstance : null;
            },
        };
    }, [rive, riveCanvasInstance]);
    (0, react_1.useEffect)(() => {
        (0, canvas_advanced_1.default)({
            locateFile: () => 'https://unpkg.com/@rive-app/canvas-advanced@2.31.5/rive.wasm',
        })
            .then((riveInstance) => {
            setRiveCanvas(riveInstance);
            continueRender(handle);
        })
            .catch((newErr) => {
            setError(newErr);
        });
    }, [handle, continueRender]);
    (0, react_1.useEffect)(() => {
        if (!riveCanvasInstance) {
            return;
        }
        const renderer = riveCanvasInstance.makeRenderer(canvas.current);
        fetch(new Request(src))
            .then((f) => f.arrayBuffer())
            .then((b) => {
            riveCanvasInstance
                .load(new Uint8Array(b), assetLoader
                ? new riveCanvasInstance.CustomFileAssetLoader({
                    loadContents: assetLoader,
                })
                : undefined, enableRiveAssetCdn)
                .then((file) => {
                const artboard = typeof artboardName === 'string'
                    ? file.artboardByName(artboardName)
                    : typeof artboardName === 'number'
                        ? file.artboardByIndex(artboardName)
                        : file.defaultArtboard();
                const animation = new riveCanvasInstance.LinearAnimationInstance(typeof animationIndex === 'number'
                    ? artboard.animationByIndex(animationIndex)
                    : typeof animationIndex === 'string'
                        ? artboard.animationByName(animationIndex)
                        : artboard.animationByIndex(0), artboard);
                setRive({
                    animation,
                    artboard,
                    renderer,
                    file,
                });
            });
        })
            .catch((newErr) => {
            setError(newErr);
        });
    }, [
        animationIndex,
        artboardName,
        riveCanvasInstance,
        src,
        onLoad,
        assetLoader,
        enableRiveAssetCdn,
    ]);
    (0, react_1.useEffect)(() => {
        if (onLoad && rive) {
            onLoad(rive.file);
        }
    }, [onLoad, rive]);
    react_1.default.useEffect(() => {
        if (!riveCanvasInstance) {
            return;
        }
        riveCanvasInstance.requestAnimationFrame(() => {
            if (!rive || !canvas.current) {
                return;
            }
            const diff = frame - lastFrame.current;
            rive.renderer.clear();
            if (rive.animation) {
                rive.animation.advance(diff / fps);
                rive.animation.apply(1);
            }
            rive.artboard.advance(diff / fps);
            rive.renderer.save();
            rive.renderer.align((0, map_enums_js_1.mapToFit)(fit, riveCanvasInstance), (0, map_enums_js_1.mapToAlignment)(alignment, riveCanvasInstance.Alignment), {
                minX: 0,
                minY: 0,
                maxX: canvas.current.width,
                maxY: canvas.current.height,
            }, rive.artboard.bounds);
            rive.artboard.draw(rive.renderer);
            rive.renderer.restore();
            lastFrame.current = frame;
        });
    }, [frame, fps, rive, riveCanvasInstance, fit, alignment]);
    const style = (0, react_1.useMemo)(() => ({
        height,
        width,
    }), [height, width]);
    return (0, jsx_runtime_1.jsx)("canvas", { ref: canvas, width: width, height: height, style: style });
};
exports.RemotionRiveCanvas = (0, react_1.forwardRef)(RemotionRiveCanvasForwardRefFunction);
